import GenericDataError, { GenericDataErrorType} from "./GenericDataError";
export default GenericDataError;
export { GenericDataErrorType };
